import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=276d5b22&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"
import style0 from "./finish.vue?vue&type=style&index=0&id=276d5b22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d5b22",
  null
  
)

export default component.exports